// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__YXlrE","containerItemsCenter":"Skeleton_containerItemsCenter__2G5OS"};